import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addToWisshList, getWishList, removeFromWishList } from "./wishListAPI";
import { WishlistDataState } from "../../../features/view/private/profilePage/components/ProfilePageTypes";

const initialState: WishlistDataState = {
  wishList: { data: [], loader: false },
};

export const addToWisshListAsync = createAsyncThunk(
  "products/wishlist/add/",
  async (id: any) => {
    const response = await addToWisshList(id);
    return response;
  }
);

export const removeFromWishListAsync = createAsyncThunk(
  "products/wishlist/remove/",
  async (id: any) => {
    const response = await removeFromWishList(id);
    return response;
  }
);

export const getWishListAsync = createAsyncThunk(
  "/products/wishlist/",
  async () => {
    const response = await getWishList();
    return response;
  }
);

export const wishListSlice = createSlice({
  name: "wishList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(addToWisshListAsync.pending, (state) => {
        state.wishList.loader = true;
      })
      .addCase(addToWisshListAsync.fulfilled, (state, action: any) => {
        state.wishList.loader = false;
        state.wishList.data = action?.payload?.data || [];
      })
      .addCase(addToWisshListAsync.rejected, (state) => {
        state.wishList.loader = false;
      })
      .addCase(removeFromWishListAsync.pending, (state) => {
        state.wishList.loader = true;
      })
      .addCase(removeFromWishListAsync.fulfilled, (state, action: any) => {
        state.wishList.loader = false;
        state.wishList.data = action?.payload?.data || [];
      })
      .addCase(removeFromWishListAsync.rejected, (state) => {
        state.wishList.loader = false;
      });
  },
});

export default wishListSlice.reducer;
